import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import * as echarts from "echarts";
import api from "@/api";
export default {
  name: "NoteDataChart",
  components: {},
  props: {
    noteId: {
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  methods: {
    init() {
      api.getNoteData(this.noteId).then(ret => {
        this.render(ret);
      });
    },
    render(list) {
      const option = {
        title: {
          text: '素材数据走势'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['收藏数', '留言数', '分享数', '喜欢数', '浏览数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: list.map(l => l.date)
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '收藏数',
          type: 'line',
          data: list.map(l => l.collectedCount ? l.collectedCount : 0)
        }, {
          name: '留言数',
          type: 'line',
          data: list.map(l => l.commentCount ? l.commentCount : 0)
        }, {
          name: '分享数',
          type: 'line',
          data: list.map(l => l.shareCount ? l.shareCount : 0)
        }, {
          name: '喜欢数',
          type: 'line',
          data: list.map(l => l.likedCount ? l.likedCount : 0)
        }, {
          name: '浏览数',
          type: 'line',
          data: list.map(l => l.viewCount ? l.viewCount : 0)
        }]
      };
      let pie = document.getElementById('noteChart');
      let exist = echarts.getInstanceByDom(pie);
      if (exist) {
        console.log(this.id, '销毁已存在的');
        exist.dispose();
      }
      let chart = echarts.init(pie);
      chart.setOption(option);
    }
  },
  mounted() {
    this.init();
  }
};